export const checkLoginUser = () => {
    return (
        localStorage.getItem("isap_cognitouser_site") !== null ? (true) : (false)
    )
}